import truncate from 'lodash/truncate'
import { Maybe } from 'types/graphqlTypes'

interface IGetTruncatedPostalCodeOptions {
  /**
   * @example 'US'
   */
  countryCode: string | undefined
}

/**
 * @example getTruncatedPostalCode('12345-9103') // '12345'
 */
export const getTruncatedPostalCode = (
  postalCode: Maybe<string>,
  options: IGetTruncatedPostalCodeOptions
): string => {
  if (!postalCode) {
    return ''
  }

  const { countryCode } = options || {}
  if (countryCode === 'US') {
    return truncate(postalCode, { length: 5, omission: '' })
  }

  return postalCode
}
